module.exports = __webpack_public_path__ + "img/c2.5e7a039b.png";